const doc = [({"ja":({"adminConstantPayType":({"prePayment":"事前決済", "onSite":"現地決済", "all":"全ての決済手段で可能"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;